import { inject, Injectable } from '@angular/core';
import { RequestsApiService } from './requests-api.service';

@Injectable({
  providedIn: 'root',
})
export class RequestSettingsService {
  private readonly requestsApiService = inject(RequestsApiService);

  getCheckList$(counterpartyId: number) {
    return this.requestsApiService.getCheckList$(counterpartyId);
  }
}
